import { render, staticRenderFns } from "./manageModel.vue?vue&type=template&id=2d053780&scoped=true&"
import script from "./manageModel.vue?vue&type=script&lang=js&"
export * from "./manageModel.vue?vue&type=script&lang=js&"
import style0 from "./manageModel.vue?vue&type=style&index=0&id=2d053780&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d053780",
  null
  
)

export default component.exports